module.exports = __webpack_public_path__ + "img/Faux Wood.459d1d31.jpg";